import DB from "@/common/utils/db";

/**
 * @description 获取PA分享
 */
export function getList(query) {
  return DB({
    url: "v1/positions/share/" + query.id,
    method: "get",
    params: query
  });
}